// ════════════════════════════════════════════════════════════════════════════
// ✅ api/publicSosApi.js — Frontend API calls
// ════════════════════════════════════════════════════════════════════════════

import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/public-sos`,
});

// ── Helper: auth header ──────────────────────
const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// ════════════════════════════════════════════════════════════════════════════
// ✅ Admin: Fetch all public SOS (paginated + search + filter)
// ════════════════════════════════════════════════════════════════════════════
// payload: { n_limit, n_page, c_search_term, c_status }
export async function getAllPublicSOS(payload) {
  try {
    const res = await API.post("/all", payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ✅ Admin: Resolve a public SOS
// ════════════════════════════════════════════════════════════════════════════
// payload: { resolvedBy, resolutionNote }
export async function resolvePublicSOS(id, payload = {}) {
  try {
    const res = await API.patch(`/${id}/resolve`, payload, {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ✅ Admin: Get single public SOS by ID (with full details)
// ════════════════════════════════════════════════════════════════════════════
export async function getPublicSOSById(id) {
  try {
    const res = await API.get(`/${id}`, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ✅ Admin: Get public SOS stats (active, responded, resolved counts)
// ════════════════════════════════════════════════════════════════════════════
export async function getPublicSOSStats() {
  try {
    const res = await API.get("/stats", { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ✅ Admin: Delete a public SOS (soft delete or hard delete)
// ════════════════════════════════════════════════════════════════════════════
export async function deletePublicSOS(id) {
  try {
    const res = await API.delete(`/${id}`, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ✅ api/publicSosApi.js — ADD this new function
// ════════════════════════════════════════════════════════════════════════════

// ✅ Admin: Mark SOS as fake
export async function markPublicSOSAsFake(id, payload = {}) {
  try {
    const res = await API.patch(`/${id}/fake`, payload, {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ✅ Admin: Get passenger's fake SOS history
export async function getPassengerFakeHistory(passengerId) {
  try {
    const res = await API.get(`/fake-history/${passengerId}`, {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ✅ routes/publicSosRoutes.js — ADD these 2 routes
// ════════════════════════════════════════════════════════════════════════════
// router.patch("/:id/fake", protect, adminOnly, markPublicSOSAsFake);
// router.get("/fake-history/:passengerId", protect, adminOnly, getPassengerFakeHistory);